import React from 'react'
import ListContentBlocks from '../../../react4xp/components/ListContentBlocks'


function ListContentBlocksPart({ contentBlocks }) {
	return <ListContentBlocks
		contentBlock={contentBlocks?.map(contentBlock => ({
			img: contentBlock.image?.link && {
				src: contentBlock.image.link,
				alt: contentBlock.image.alt
			},
			title: contentBlock.title,
			text: `<p>${contentBlock.intro}</p>`
		}))}
	/>
}

export default (props) => <ListContentBlocksPart {...props} />
